export default "__VITE_ASSET__GwJAnphH__"